// extracted by mini-css-extract-plugin
module.exports = {"contacts":"Contacts_contacts___4Ykx","container":"Contacts_container__jKTJi","grid":"Contacts_grid__oD3WD"};